import {reactive} from "vue";

export default reactive({
    execute(siteKey, element, callback) {
        function ready() {
            let timeout = setTimeout(() => {
                timeout = undefined;
                callback();
            }, 10000);
            window.turnstile.execute(element, {
                sitekey: siteKey,
                callback: token => {
                    if (timeout) {
                        clearTimeout(timeout);
                        callback(token);
                    }
                }
            });
        }
        if (window.turnstile) {
            ready();
        } else {
            window.onloadTurnstileCallback = () => {
                ready();
            }
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }
    }
});